import { CompactUserResponse } from '../account';
import { PageQuery } from '../common';
import { CourseId } from '../course/CourseResponse';
import { UserCourseId } from '../user_course';
import { CourseInboxUserType } from './CourseInboxReplyResponse';

export type CourseInboxId = string;

export enum CourseInboxStatus {
  open = 'Open', // Open
  replied = 'Replied', // Replied
  closed = 'Closed', // cLOSED
}

export const courseInboxStatuses = [CourseInboxStatus.open, CourseInboxStatus.replied, CourseInboxStatus.closed];

export enum CourseInboxType {
  essay = 'essay',
}

export interface CourseInboxResponse {
  id: CourseInboxId;
  blockId: string;
  courseId: UserCourseId;
  mainCourseId: CourseId;
  enroller: CompactUserResponse;
  instructor: CompactUserResponse;
  subject: string;
  message: string;
  type: CourseInboxType;
  status: CourseInboxStatus;
  createdAt: number;
  updatedAt: number;
}

export interface CourseInboxSearchParams extends PageQuery {
  stageId?: string;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  dateRange?: string;
  type?: CourseInboxUserType;
  // search?: string;
}

export interface UnreadInboxMessages {
  studentMessageCount: number;
  instructorMessageCount: number;
}
